export default __webpack_public_path__ + "static/media/small_head_-3.c6392631.webp";